<template>
  <div class="reproductor-container">
    <!-- Texto superior -->

    <!-- Reproductor de música -->
    <div class="music-wrapper">
      <audio
        ref="audio"
        :src="songSource"
        preload="auto"
        autoplay
        @timeupdate="updateProgress"
        @ended="resetPlayer"
      />

      <button @click="togglePlay" class="play-button">
        <i :class="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
      </button>

      <span class="time">{{ currentTime }}</span>

      <input
        type="range"
        class="progress-bar"
        min="0"
        max="100"
        step="0.1"
        :value="progress"
        @input="seekMusic"
      />

      <span class="time">{{ duration }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      songSource: require('@/assets/musicafondo.mp3'),
      isPlaying: false,
      progress: 0,
      currentTime: '00:00',
      duration: '00:00'
    };
  },
  mounted() {
    const audio = this.$refs.audio;
    audio.onloadedmetadata = () => {
      this.duration = this.formatTime(audio.duration);
    };

    // Forzar reproducción automática (muchos navegadores la bloquean sin interacción)
    audio.play().then(() => {
      this.isPlaying = true;
    }).catch(() => {
      // Si el navegador lo bloquea, queda pausado
      this.isPlaying = false;
    });
  },
  methods: {
    togglePlay() {
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    updateProgress() {
      const audio = this.$refs.audio;
      this.progress = (audio.currentTime / audio.duration) * 100;
      this.currentTime = this.formatTime(audio.currentTime);
    },
    seekMusic(event) {
      const audio = this.$refs.audio;
      const newTime = (event.target.value / 100) * audio.duration;
      audio.currentTime = newTime;
    },
    resetPlayer() {
      this.isPlaying = false;
      this.progress = 0;
      this.currentTime = '00:00';
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
  }
};
</script>

<style scoped>
.reproductor-container {
  position: relative;
  width: 100%;
  margin-top: 20px;
}

.texto-reproductor {
  text-align: center;
  font-family: 'padres';
  font-size: 14px;
  background-color: white;
  padding: 12px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: 6px;
  text-transform: uppercase;
  color: #4d0404;
  margin-bottom: 20px;
  z-index:10;
}

.music-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 10px;
}

.play-button {
  background-color: #43050d; 
  color: white;
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
}

.play-button i {
  pointer-events: none;
}

.progress-bar {
  flex-grow: 1;
  height: 6px;
  border-radius: 4px;
  background: #ddd;
  appearance: none;
  outline: none;
}

.time {
  font-family: 'padres';
  font-size: 13px;
  color: #333;
}
</style>
